// Per-iPad station selection persistence.
//
// The counter POS supports 2-3 physical iPads at the same counter. Each
// iPad picks its station once on the lock screen (PosStationPicker) and
// remembers the choice locally so a hard refresh doesn't kick staff back
// to the picker mid-shift. The server also claims the station for this
// iPad's device id so another iPad cannot share the same TID / printer.
// Release via Change station, Admin → Release, or 2 hours with no
// POS activity (sales / settings / staff taps).
//
// Storage shape:
//   posStationKey       — URL-safe slug (e.g. "station-1") matching the
//                         pos_stations.station_key column on the server.
//   posStationName      — display name at the moment of pick; used as a
//                         hint in the header while the config API loads.
//
// We wrap localStorage in try/catch so private-browsing / storage-full
// scenarios degrade gracefully to "no station picked" instead of white-
// screening the whole POS.

const KEY = 'posStationKey';
const NAME_KEY = 'posStationName';
const DEVICE_KEY = 'posDeviceId';

function safeGet(key) {
  try {
    return window.localStorage.getItem(key) || '';
  } catch {
    return '';
  }
}

function safeSet(key, value) {
  try {
    if (value === null || value === undefined || value === '') {
      window.localStorage.removeItem(key);
    } else {
      window.localStorage.setItem(key, String(value));
    }
  } catch {
    /* swallow — see rationale above */
  }
}

export function getDeviceId() {
  let id = safeGet(DEVICE_KEY);
  if (id) return id;
  id = (typeof crypto !== 'undefined' && crypto.randomUUID)
    ? crypto.randomUUID()
    : `pos-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
  safeSet(DEVICE_KEY, id);
  return id;
}

export function getStationKey() {
  return safeGet(KEY);
}

export function getStationName() {
  return safeGet(NAME_KEY);
}

export function setStation(key, name) {
  safeSet(KEY, key);
  if (name) safeSet(NAME_KEY, name);
}

export function clearStation() {
  safeSet(KEY, '');
  safeSet(NAME_KEY, '');
}
